<template>
  <StandardEmptyPageContainer>
    <LoadingCircle v-if="isLoading" />
    <div v-else>
      <v-row>
        <v-col cols="12" sm="12" lg="6">
          <PendingRequestsWidget
            :received-questionnaires="questionnaireStore.receivedQuestionnaires"
          />
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <StandardCardContainer
            radius="small"
            :clickable="true"
            @clicked="goToAboutTheAct"
            class="fill-height"
          >
            <v-row class="fill-height align-center">
              <v-col class="my-3">
                <PIllustrationWithText
                  text="About the Transparency Act"
                  imgsrc="/assets/pictogram-justice-legal.svg"
                  size="xs"
                  textsize="h3"
                />
              </v-col>
            </v-row>
          </StandardCardContainer>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <StandardCardContainer
            radius="small"
            @clicked="goToAboutTransparencyChain"
            :clickable="true"
            class="fill-height"
          >
            <v-row class="fill-height align-center">
              <v-col>
                <PIllustrationWithText
                  text="How does this work?"
                  imgsrc="/assets/pictogram-roadmap.svg"
                  size="xs"
                  textsize="h3"
                  class="my-auto"
                />
              </v-col>
            </v-row>
          </StandardCardContainer>
        </v-col>
      </v-row>
      <v-row v-if="!tasksDone">
        <v-col cols="12" sm="6" lg="4" xl="3">
          <StandardCardContainer
            radius="small"
            @clicked="routeToTeamView"
            :clickable="true"
          >
            <v-row>
              <v-col class="text-left">
                <h2>Wrong recipient?</h2>
                <p class="mt-2">Add colleagues</p>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <PIllustrationWithText text="" illustration="1" />
              </v-col>
            </v-row>
          </StandardCardContainer>
        </v-col>
      </v-row>
    </div>
  </StandardEmptyPageContainer>
</template>

<script setup lang="ts">
import StandardEmptyPageContainer from "@/components/containers/StandardEmptyPageContainer.vue";
import PendingRequestsWidget from "@/views/supplier-dashboard-view/PendingRequestsWidget.vue";
import { genericError } from "@/modules/utilities";
import { onBeforeMount, ref, computed } from "vue";
import { useQuestionnairesStore } from "@/stores/questionnaires";
import { useSnackBarStore } from "@/stores/snackBarStore";
import LoadingCircle from "@/components/custom/LoadingCircle.vue";
import { useRouter } from "vue-router";
import { RouterPath } from "@/models/enum/routerPath";
import { AnswerStatus } from "@/models/enum/answerStatus";
import PIllustrationWithText from "@/components/custom/PIllustrationWithText.vue";
import StandardCardContainer from "@/components/containers/StandardCardContainer.vue";

const questionnaireStore = useQuestionnairesStore();
const snackbarStore = useSnackBarStore();
const isLoading = ref(true);
const router = useRouter();

onBeforeMount(async () => {
  await fetchData();
});

const fetchData = async () => {
  try {
    isLoading.value = true;
    await questionnaireStore.getSentAndReceivedQuestionnaires();
  } catch (error) {
    snackbarStore.showError(genericError);
  } finally {
    isLoading.value = false;
  }
};

function routeToTeamView() {
  router.push(RouterPath.Team);
}

const tasksDone = computed(
  () =>
    questionnaireStore.receivedQuestionnaires.questionnaires.filter(
      (q) => q.answerStatus != AnswerStatus.Completed
    ).length == 0
);

function goToAboutTheAct() {
  router.push(RouterPath.AboutTheAct);
}

function goToAboutTransparencyChain() {
  router.push(RouterPath.AboutTransparencyChain);
}
</script>
